import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const RepaymentTestUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted, status,
    clearDataMode,
    // event handlers
    onSubmit, onClearDataClick, onCancelClick, onClearDataCancelClick,
    // fields
    scheduledDateISO, onScheduledDateISOChange, scheduledDateISOError, setScheduledDateISOError,
    defaultInterest, onDefaultInterestChange, defaultInterestError, setDefaultInterestError,
    defaultInterestPaid, onDefaultInterestPaidChange, defaultInterestPaidError, setDefaultInterestPaidError,
    interestOnOverduePrincipal, onInterestOnOverduePrincipalChange, interestOnOverduePrincipalError, setInterestOnOverduePrincipalError,
    interestOnOverduePrincipalPaid, onInterestOnOverduePrincipalPaidChange, interestOnOverduePrincipalPaidError, setInterestOnOverduePrincipalPaidError,
    interestOnOverdueInterest, onInterestOnOverdueInterestChange, interestOnOverdueInterestError, setInterestOnOverdueInterestError,
    interestOnOverdueInterestPaid, onInterestOnOverdueInterestPaidChange, interestOnOverdueInterestPaidError, setInterestOnOverdueInterestPaidError,
    interestPaid, onInterestPaidChange, interestPaidError, setInterestPaidError,
    principalPaid, onPrincipalPaidChange, principalPaidError, setPrincipalPaidError,
}) =>
    <ModalFormUI
        context={context}
        titleLabel={updateMode === true ? 'Repayment Test Update' : 'Delete Test Data'}
        buttonLabel={updateMode === true ? 'Update' : 'Delete'}
        cancelLabel='Cancel'
        isOpen={updateMode === true ? updateMode : clearDataMode}
        onRequestClose={clearDataMode === true ? onClearDataCancelClick : onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={updateMode === true ? onSubmit : onClearDataClick}
        busy={submitted}
    >
        <div className='g_flex_h '>
            <div>

                <InputTextSF type='text' name='Scheduled Date ISO' maxLength={12}
                    label='Scheduled Date ISO' help='Eg : 1923-02-30'
                    value={scheduledDateISO} onChange={onScheduledDateISOChange}
                    error={scheduledDateISOError} setError={setScheduledDateISOError}
                />
                {
                    updateMode === true &&
                    <div>
                        <InputTextSF type='text' name='Default Interest' maxLength={12}
                            label='Default Interest'
                            value={defaultInterest} onChange={onDefaultInterestChange}
                            error={defaultInterestError} setError={setDefaultInterestError}
                        />
                        <InputTextSF type='text' name='Default Interest Paid' maxLength={12}
                            label='Default Interest Paid'
                            value={defaultInterestPaid} onChange={onDefaultInterestPaidChange}
                            error={defaultInterestPaidError} setError={setDefaultInterestPaidError}
                        />
                        <InputTextSF type='text' name='Interest On Overdue Principal' maxLength={12}
                            label='Interest On Overdue Principal'
                            value={interestOnOverduePrincipal} onChange={onInterestOnOverduePrincipalChange}
                            error={interestOnOverduePrincipalError} setError={setInterestOnOverduePrincipalError}
                        />
                        <InputTextSF type='text' name='Interest On Overdue Principal Paid' maxLength={12}
                            label='Interest On Overdue Principal Paid'
                            value={interestOnOverduePrincipalPaid} onChange={onInterestOnOverduePrincipalPaidChange}
                            error={interestOnOverduePrincipalPaidError} setError={setInterestOnOverduePrincipalPaidError}
                        />
                    </div>
                }
            </div>
            {
                updateMode === true &&
                <div style={{ marginLeft: '20px' }}>
                    <InputTextSF type='text' name='Interest On Overdue Interest' maxLength={12}
                        label='Interest On Overdue Interest'
                        value={interestOnOverdueInterest} onChange={onInterestOnOverdueInterestChange}
                        error={interestOnOverdueInterestError} setError={setInterestOnOverdueInterestError}
                    />
                    <InputTextSF type='text' name='Interest On Overdue Interest Paid' maxLength={12}
                        label='Interest On Overdue Interest Paid'
                        value={interestOnOverdueInterestPaid} onChange={onInterestOnOverdueInterestPaidChange}
                        error={interestOnOverdueInterestPaidError} setError={setInterestOnOverdueInterestPaidError}
                    />
                    <InputTextSF type='text' name='Interest Paid' maxLength={12}
                        label='Interest Paid'
                        value={interestPaid} onChange={onInterestPaidChange}
                        error={interestPaidError} setError={setInterestPaidError}
                    />
                    <InputTextSF type='text' name='Principal Paid' maxLength={12}
                        label='Principal Paid'
                        value={principalPaid} onChange={onPrincipalPaidChange}
                        error={principalPaidError} setError={setPrincipalPaidError}
                    />
                </div>
            }
        </div>
    </ModalFormUI>

// {
//     clearDataMode === true &&
//         <ModalFormUI
//             context={context}
//             titleLabel='Repayment Test Update'
//             buttonLabel='Update'
//             cancelLabel='Cancel'
//             isOpen={updateMode}
//             onRequestClose={onCancelClick}
//             successMsg={successMsg}
//             errorList={errorList}
//             setErrorList={setErrorList}
//             onSubmit={onSubmit}
//             busy={submitted}
//         >
//             <InputTextSF type='text' name='Scheduled Date ISO' maxLength={12}
//                 label='Scheduled Date ISO' help='Eg : 1923-02-30'
//                 value={scheduledDateISO} onChange={onScheduledDateISOChange}
//                 error={scheduledDateISOError} setError={setScheduledDateISOError}
//             />
//         </ModalFormUI>
// }

export default RepaymentTestUpdateModalUI
